import {Record, List} from 'immutable';

function googleStylesheetUrl(typefaces) {
  const family = typefaces.first().family;
  const weightsAndStyles = typefaces.map((typeface) => {
    return `${typeface.weight}${(typeface.style !== 'normal') ? typeface.style : ''}`;
  }).join(',');
  const familyQuery = `${family}:${weightsAndStyles}`;

  return `https://fonts.googleapis.com/css?family=${familyQuery}`;
}

function customStylesheetUrl(typefaces) {
  const family = typefaces.first().family;

  return `/api/typefaces/stylesheet?family=${family}`;
}

export function stylesheetUrl(typefaces) {
  let normalizedTypefaces = typefaces;

  if (!normalizedTypefaces) {
    throw new Error('No typefaces provided');
  }

  if (normalizedTypefaces instanceof Record) {
    normalizedTypefaces = List([typefaces]);
  }

  return (normalizedTypefaces.first().system) ? googleStylesheetUrl(normalizedTypefaces) : customStylesheetUrl(normalizedTypefaces);
}



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/utils/typefaces.js